import { useCallback, useRef } from "react";
import { toToken } from "./emailUtils";

const usePlaceholderInsert = (subject, setSubject) => {
  const subjectRef = useRef(null);
  const editorRef = useRef(null);

  const handleEditorReady = useCallback((editor) => {
    editorRef.current = editor;
  }, []);

  const insertPlaceholder = useCallback(
    (key) => {
      const token = toToken(key);
      const subjectEl = subjectRef.current;

      if (subjectEl && document.activeElement === subjectEl) {
        const start = subjectEl.selectionStart ?? subject.length;
        const end = subjectEl.selectionEnd ?? subject.length;
        setSubject(subject.slice(0, start) + token + subject.slice(end));
        requestAnimationFrame(() => {
          subjectEl.focus();
          subjectEl.setSelectionRange(
            start + token.length,
            start + token.length,
          );
        });
        return;
      }

      const editor = editorRef.current;
      if (editor && !editor.isDestroyed) {
        editor.chain().focus().insertContent(token).run();
      }
    },
    [subject, setSubject],
  );

  return { subjectRef, handleEditorReady, insertPlaceholder };
};

export default usePlaceholderInsert;
